import BaseBoxView from "./BaseBoxView";
import GameElementSkinFactory from "./GameElementSkinFactory";

export default class ExampleBoxView extends BaseBoxView {
    
    /**
     * @param {createjs.DisplayObject} target 
     * @param {GameElementSkinFactory} elementFactory 
     */
    constructor(target, elementFactory) {
        super(target, elementFactory);
        this._enabled = false;
    }
}
